import { render, staticRenderFns } from "./verifyAddress.vue?vue&type=template&id=2277aff6&scoped=true"
import script from "./verifyAddress.vue?vue&type=script&lang=js"
export * from "./verifyAddress.vue?vue&type=script&lang=js"
import style0 from "./verifyAddress.vue?vue&type=style&index=0&id=2277aff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277aff6",
  null
  
)

export default component.exports